export const SELECTED_CITY_COOKIE_NAME = "selected_city";
export const CITY_SLUG_COOKIE_NAME = "city_slug";
export const USER_SELECTED_CITY_COOKIE_NAME = "ad_city_user_selected";
export const APP_LOCATION_CITY_COOKIE_NAME = "city";
